
export default {
	name: 'NullValue',
	handler: {
		init: function (element, valueAccessor, allBindingsAccessor) {
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			if (valueUnwrapped === null || valueUnwrapped === undefined)
				$(element).text('-');
			else
				$(element).text(valueUnwrapped);
		}
	}
};
